import { render, staticRenderFns } from "./DeactivateAsset.vue?vue&type=template&id=f77a704e&scoped=true&"
import script from "./DeactivateAsset.vue?vue&type=script&lang=js&"
export * from "./DeactivateAsset.vue?vue&type=script&lang=js&"
import style0 from "./DeactivateAsset.vue?vue&type=style&index=0&id=f77a704e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f77a704e",
  null
  
)

export default component.exports